// Shared interactions for the listicle-* sections (sections/listicle-*.liquid)
(function () {
  // Multiple listicle-*.liquid sections each inject their own
  // <script src="listicle.js"> tag, so this file's top-level code can run
  // many times on one page — without this guard every init* function below
  // would bind its document-level listener once per section instance,
  // causing each click to fire N times (and visibly cancel itself out,
  // e.g. an accordion item that won't reopen).
  if (window.__listicleJsInitialized) return;
  window.__listicleJsInitialized = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // ---------- Reason-card / accordion blocks ----------
  function initAccordions() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.listicle-reason__accordion-trigger');
      if (!trigger) return;

      var item = trigger.closest('.listicle-reason__accordion-item');
      if (!item) return;

      // Each item toggles independently — opening one must not collapse
      // the others.
      var isOpen = item.getAttribute('data-open') === 'true';
      item.setAttribute('data-open', isOpen ? 'false' : 'true');
    });
  }

  // ---------- Trust video circles ----------
  function trustVideoPlay(media) {
    var video = media && media.querySelector('video');
    var playBtn = media && media.querySelector('.listicle-trust-videos__play');
    var muteBtn = media && media.querySelector('.listicle-trust-videos__mute');
    if (!video) return;

    // Only one trust video should play at a time.
    Array.prototype.forEach.call(document.querySelectorAll('.listicle-trust-videos__media'), function (other) {
      if (other === media) return;
      var otherVideo = other.querySelector('video');
      if (otherVideo && !otherVideo.paused) trustVideoPause(other);
    });

    video.muted = false;
    var playPromise = video.play();
    var onPlaying = function () {
      if (playBtn) playBtn.hidden = true;
      if (muteBtn) {
        muteBtn.hidden = false;
        muteBtn.textContent = video.muted ? 'Unmute' : 'Mute';
      }
    };
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(onPlaying).catch(function () {
        // Interrupted/blocked — leave the play button visible.
      });
    } else {
      onPlaying();
    }
  }

  function trustVideoPause(media) {
    var video = media && media.querySelector('video');
    var playBtn = media && media.querySelector('.listicle-trust-videos__play');
    var muteBtn = media && media.querySelector('.listicle-trust-videos__mute');
    if (!video) return;
    video.pause();
    if (playBtn) playBtn.hidden = false;
    if (muteBtn) muteBtn.hidden = true;
  }

  function initTrustVideos() {
    document.addEventListener('click', function (event) {
      var playBtn = event.target.closest('.listicle-trust-videos__play');
      if (playBtn) {
        trustVideoPlay(playBtn.closest('.listicle-trust-videos__media'));
        return;
      }

      var muteBtn = event.target.closest('.listicle-trust-videos__mute');
      if (muteBtn) {
        var media = muteBtn.closest('.listicle-trust-videos__media');
        var video = media && media.querySelector('video');
        if (video) {
          video.muted = !video.muted;
          muteBtn.textContent = video.muted ? 'Unmute' : 'Mute';
        }
        return;
      }

      // Clicking anywhere in the circle (not a button) toggles play/pause.
      var media2 = event.target.closest('.listicle-trust-videos__media');
      if (media2) {
        var video2 = media2.querySelector('video');
        if (video2) {
          if (video2.paused) {
            trustVideoPlay(media2);
          } else {
            trustVideoPause(media2);
          }
        }
      }
    });

    document.addEventListener(
      'ended',
      function (event) {
        var video = event.target;
        if (!video.matches || !video.matches('.listicle-trust-videos__media video')) return;
        var media = video.closest('.listicle-trust-videos__media');
        var playBtn = media && media.querySelector('.listicle-trust-videos__play');
        var muteBtn = media && media.querySelector('.listicle-trust-videos__mute');
        if (playBtn) playBtn.hidden = false;
        if (muteBtn) muteBtn.hidden = true;
      },
      true
    );
  }

  // ---------- Smooth-scroll for any "#anchor" link (e.g. a CTA button whose
  // link is set to a section's Anchor ID setting) ----------
  function initAnchorScroll() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;

      var hash = link.getAttribute('href');
      if (!hash || hash.length < 2) return;

      var target;
      try {
        target = document.getElementById(decodeURIComponent(hash.slice(1)));
      } catch (e) {
        target = null;
      }
      if (!target) return;

      event.preventDefault();

      var offset = 0;
      var headerGroup = document.querySelector('.shopify-section-group-header-group');
      if (headerGroup) {
        var style = window.getComputedStyle(headerGroup);
        if (style.position === 'fixed' || style.position === 'sticky') {
          offset = headerGroup.offsetHeight;
        }
      }

      var targetY = target.getBoundingClientRect().top + window.pageYOffset - offset - 16;
      window.scrollTo({ top: Math.max(targetY, 0), behavior: 'smooth' });
    });
  }

  ready(function () {
    initAccordions();
    initTrustVideos();
    initAnchorScroll();
  });
})();
